import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import styles from './blog.module.css'
import ProgramPreview from '../components/program-preview'

class BookIndex extends React.Component {
  render() {

    const siteData = get(this.props, 'data.site.siteMetadata')
    const siteDescription = 'Kumpulan program-program YOUCAT Indonesia'
    const posts = get(this, 'props.data.allContentfulProgram.edges')

    return (
      <div style={{ background: '#fff' }} className="page-content">
      <Helmet title={`Program | ${siteData.title}`}>

          <link rel="canonical" href={`${siteData.siteUrl}/program`} />
          <meta name="description" content={`${siteDescription}`} />
          <meta name="title" content={`Program | ${siteData.title}`} />

          <meta property="og:title" content={`Program | ${siteData.title}`} />
          <meta property="og:site_name" content="YOUCAT Indonesia" />
          <meta property="og:url" content={`${siteData.siteUrl}/program`} />
          <meta property="og:description" content={`${siteDescription}`}  />
          <meta property="og:image" content="https://static.youcat.id/ogimg/ogimg-youcat.png" />
          <meta property="og:locale" content="id_ID" />
          <meta property="og:type" content="website" />

        </Helmet>

        <div className="wrapper">
          <h1 className="page-title">Program-program</h1>
          <ul className="program-list grid-x grid-padding-x grid-padding-y small-up-1 medium-up-2 large-up-3">
            {posts.map(({ node }) => {
              return (
                <li key={node.slug} className="cell program-list-item">
                  <ProgramPreview program={node} />
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

export default BookIndex

export const pageQuery = graphql`
  query ProgramIndexQuery {
    site {
      siteMetadata {
        title
        siteUrl
        siteImg
      }
    }
    allContentfulProgram(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          title
          slug
          position
          thumbnail {
            sizes(maxWidth: 640, maxHeight: 480, resizingBehavior: THUMB) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          excerpt
          programCategory
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/program.js